import React from 'react';

const Features = () => {
  return (
    <div className="features-section w-screen bg-white py-20 sm:pb-[100px] border-t">
      <div className="content max-w-[1120px] mx-auto max-sm:pt-[5vh] pt-[9vh]">
        <div className="text-indigo-600 font-semibold sm:text-lg">Expert Guidance</div>
        <div className="flex flex-col gap-4 mt-8 -ml-1">
          <h3 className="text-4xl sm:text-6xl font-bold tracking-tighter">Why partner with us?</h3>
        </div>

        <div className="flex flex-wrap gap-4 mt-8">
          <div className="bg2 w-full bg-white pt-6 px-10 pb-2 rounded-2xl fade-up flex flex-wrap items-center scroll-mt-28">
            <span id="machine-learning-ai" className="scroll-mt-28"></span>
            <div className="w-full md:w-1/2 text-center md:text-left">
              <div className="relative inline-flex items-center overflow-hidden rounded-full mx-auto mb-4">
                <div className="absolute inset-0 pill-wrapper"></div>

                <div
                  className="pill-content relative z-10 text-[13px] font-medium text-gray-600 bg-white
                  flex flex-row items-center justify-center gap-1 text-nowrap px-3 py-1"
                >
                  Built by F100 HR Engineers
                </div>
              </div>
              <h4 className="font-bold text-xl mb-4">AI & Machine Learning</h4>
              <p className="text-gray-600 text-sm mb-4 pb-6">
                Our platform combines specialized AI models for different tasks—from agentic AI data cleaning to
                understanding complex data relationships between your HRIS, payroll, and ATS.
              </p>
              <a
                href={'/contact'}
                className="learn-more-link whitespace-nowrap rounded-full text-left outline-none ring-0 transition-all focus:border-none focus:outline-none font-medium items-center gap-3 px-5 py-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 active:scale-95 duration-200 bg-indigo-600 text-white"
                target="_blank"
                rel="noopener noreferrer"
              >
                Learn more
              </a>
            </div>
            <div className="w-full md:w-1/2 flex justify-center">
              <img className="pt-4" src="/images/ai.png" alt="AI & Machine Learning" />
            </div>
          </div>
          <div
            className="bg3 flex-1 min-w-[300px] bg-white pt-6 px-10 pb-2 rounded-2xl text-center fade-up scroll-mt-28"
            style={{ flexBasis: '48%' }}
          >
            <span id="data-integrations" className="scroll-mt-28"></span>
            <div className="relative inline-flex items-center overflow-hidden rounded-full mx-auto mb-4">
              <div className="absolute inset-0 pill-wrapper"></div>
              <div
                className="pill-content relative z-10 text-[13px] font-medium text-gray-600 bg-white
                  flex flex-row items-center justify-center gap-1 text-nowrap px-3 py-1"
              >
                Data Excellence
              </div>
            </div>
            <h4 className="font-bold text-xl mb-4">Integration with any HRIS, ATS, or payroll provider</h4>
            <p className="text-gray-600 text-sm mb-4">
              Sophare integrates with your HR and finance data making it easy to
              <span data-british=" centralise"> centralize</span> disparate systems. Our platform is built to be
              flexible and scalable, so you can add more systems as your business grows.
            </p>
            <img className="pt-4" src="/images/data_integration.png" alt="Integration" />
          </div>
          <div
            className="bg3 flex-1 min-w-[300px] bg-white pt-6 px-10 pb-2 rounded-2xl text-center fade-up scroll-mt-28"
            style={{ flexBasis: '48%' }}
          >
            <span id="security" className="scroll-mt-28"></span>
            <div className="relative inline-flex items-center overflow-hidden rounded-full mx-auto mb-4">
              <div className="absolute inset-0 pill-wrapper"></div>
              <div
                className="pill-content relative z-10 text-[13px] font-medium text-gray-600 bg-white
                  flex flex-row items-center justify-center gap-1 text-nowrap px-3 py-1"
              >
                Enterprise Security
              </div>
            </div>
            <h4 className="font-bold text-xl mb-4">Security is our top priority</h4>
            <p className="text-gray-600 text-sm mb-4">
              Through our partnership with Locus Technologies (Type 2 SOC 1 and Type 2 SOC 2 verified), we implement
              comprehensive data protection measures, including infrastructure & application security, data encryption,
              business continuity & disaster recovery, and secure processes & supply chain.
            </p>
            <div className="flex justify-center">
              <img className="pt-4 w-5/12" src="/images/security.png" alt="Security" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Features;
